import React from 'react';
import { CosmosText } from '../../cosmos/web-scoped/react';

/**
 *
 * parameter "placement" expects value "above" (default) or "below"
 * parameter "position" expects keys "left" and "bottom" with percentages as values
 *
 * @param label
 * @param style
 * @param position
 * @param placement
 * @param onClick
 * @returns {JSX.Element}
 * @constructor
 */
const Marker = ({ label, classNames, style, position, placement = 'above', onClick = {} }) => {
  const styles = {
    left: position.left,
    bottom: position.bottom,
  };

  return (
    <div
      className={`marker ${classNames} placement-${placement}`}
      style={{...styles, ...style}}
      onClick={onClick}>
      <div className="marker-indicator">
        <CosmosText size="large" weight="bold">{ label }</CosmosText>
      </div>
    </div>
  );
};

export { Marker };
